<ng-container *ngIf="(impersonatedBy$ | async) === null">
  <div class="text">
    {{ survey?.text | translate }}
  </div>

  <button pso-button [size]="'s'" [color]="'supporting-5-light-blue'" (click)="onActionButtonClick()">
    {{ 'complete-the-survey' | translate | uppercase }}
  </button>
</ng-container>
